import React, {PureComponent, CSSProperties} from 'react'
import cxs from 'cxs/component'
import {opacity} from 'helpers/Colors'
import Theme from 'Theme'
import UserRecovery from 'modules/Users/containers/UserRecovery'
import {Logo} from 'components'
import {Icon} from 'elements'

class Recovery extends PureComponent {
  render() {
    return (
      <Wrapper>
        <StyledLogo width={250} />
        <UserRecovery />
      </Wrapper>
    )
  }
}

export default Recovery

const Wrapper = cxs('div')({
  boxShadow: `0 0 100px -20px ${opacity(0.25, Theme.color.primary)}`,
  margin: 'auto',
  borderWidth: `${Theme.size.hairline}`,
  borderColor: Theme.color.hairline,
  borderStyle: 'solid'
} as CSSProperties)

const StyledLogo = cxs(Logo)({
  margin: `${Theme.size.space[4]} ${Theme.size.space[4]} 0 ${Theme.size
    .space[4]}`
} as CSSProperties)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/scenes/Recovery.tsx